<template>
  <div class="page-add form-container">
    <div class="add-title">新增专区</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="120px"
      :model="form"
      :rules="rules"
      ref="basicForm"
    >
      <el-row>
        <el-col>
          <el-form-item label="专区名称：" prop="regionTitle">
            <el-input
              placeholder="请输入专区名称"
              clearable
              show-max-limit
              maxlength="20"
              v-model="form.regionTitle"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="APP配图：" prop="appUrl" required>
            <av-preview
              v-if="form.appUrl"
              :src="form.appUrl"
              type="image"
              @delete="removeImage('appUrl')"
            />
            <template v-else>
              <upload
                :draggable="false"
                :path="'avatar/img'"
                type="image"
                v-model="form._appUrl"
              />
              <span class="tip_img">建议尺寸：1125px*632px（或16:9）</span>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="WEB配图：" prop="webUrl" required>
            <av-preview
              v-if="form.webUrl"
              :src="form.webUrl"
              type="image"
              @delete="removeImage('webUrl')"
            />
            <template v-else>
              <upload
                :draggable="false"
                :path="'avatar/img'"
                type="image"
                v-model="form._webUrl"
              />
              <span class="tip_img">建议尺寸：888px*500px（或16:9）</span>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="专区版式：" prop="showType" required>
            <el-radio-group v-model="form.showType">
              <el-tooltip
                placement="bottom"
                effect="light"
                popper-class="custom_img_poper"
                :visible-arrow="false"
                v-for="item in typeList"
                :key="item.paramKey"
              >
                <template v-if="item.toooltipImageSrc">
                  <div slot="content">
                    <img
                      :src="item.toooltipImageSrc"
                      class="app_display_mode"
                    />
                  </div>
                </template>
                <el-radio :label="item.paramKey">{{
                  item.paramValue
                }}</el-radio>
              </el-tooltip>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item
            class="scale"
            label="展示数量："
            prop="showNum"
            required
          >
            <el-input-number
              v-model="form.showNum"
              placeholder="请输入展示数量"
              clearable
              :step="1"
              :max="10"
              :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-row :span="12">
          <el-form-item label="视频列表：" required>
            <div class="custom-table" style="text-align: right">
              <div class="btn-list">
                <el-checkbox :value="draggable" @change="onCheck"
                  >拖拽排序</el-checkbox
                >
                <el-button :disabled="canMultiRemove" @click="multiRemove"
                  >批量删除</el-button
                >
                <el-button type="primary" @click="open">视频配置</el-button>
              </div>
              <BaseTable
                :class="{ 'list-drag': draggable }"
                :data="selectedList"
                @selection-change="onSelectionChange"
                @remove="onRemove"
                row-key="uuid"
              />
            </div>
          </el-form-item>
        </el-row>
      </el-row>
      <el-form-item class="center" label-width="0">
        <el-button type="primary" @click="submit">提交</el-button>
        <back-button :pathOptions="pathOptions" :floatLeft="false" />
      </el-form-item>
    </el-form>
    <ConfigSelect
      v-if="selectDialogInfo.flag"
      :showSelect="selectDialogInfo"
      @confirm="onFilter"
      @close="closeSelect"
     />
  </div>
</template>

<script>
import { getDataMap } from "@/api/sysParam";
import modeFour from "@/assets/image/img_display_mode_four.png";
import modeOne from "@/assets/image/img_display_mode_one.png";
import modeThree from "@/assets/image/img_display_mode_three.png";
import modeTwo from "@/assets/image/img_display_mode_two.png";
import AvPreview from "@/components/av-preview/index";
import BackButton from "@/components/backButton/index.vue";
import Upload from "@/components/upload/index";
import { addPart, editPart, getPartDetail } from "@/pages/part/api";
import { setItem } from "@/utils/storage.js";
import Sortable from "sortablejs";
import ConfigSelect from "./configSelect.vue";
import rules from "./rules";
import BaseTable from "./table";

const App_DISPLAY_MODE = {
  ONE: modeOne,
  TWO: modeTwo,
  THREE: modeThree,
  FOUR: modeFour,
};

export default {
  name: "PartAdd",

  components: {
    Upload,
    AvPreview,
    BaseTable,
    BackButton,
    ConfigSelect
  },

  data() {
    return {
      pathOptions: {
        path: "/part",
      },
      rules,
      form: {
        uuid: "",
        regionTitle: "",
        appUrl: "",
        _appUrl: [],
        webUrl: "",
        _webUrl: [],
        showType: "",
        showNum: "",
      },
      selectDialogInfo: {
        flag: false,
        selectedList: []
      },
      typeList: [],
      selectedList: [],
      filteredSelectedList: [],
      draggable: false,
      // sort: null,
    };
  },

  computed: {
    canMultiRemove() {
      return !this.selectedList.length;
    },
  },

  watch: {
    "form._appUrl": {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.form.appUrl = newVal[0].url || "";
        }
      },
    },
    "form._webUrl": {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.form.webUrl = newVal[0].url || "";
        }
      },
    },
    draggable(val) {
      this.toggleDrag(val);
    },
  },

  created() {
    this.initTypeList().forEach((item) =>
      this.getDictionary({ ...item }, item.field)
    );

    const { id } = this.$route.query;
    if (id) {
      this.form.uuid = id;
      this.getPartInfoById();
    }
  },

  methods: {
    // 接口请求
    initTypeList() {
      return [
        {
          name: "职务类别",
          type: "REGION_SHOW_TYPE",
          field: "typeList",
        },
      ];
    },

    // 获取数据字典
    getDictionary(params, field) {
      params =
        typeof params === "object"
          ? params !== null
            ? params
            : {}
          : { type: params };
      const TYPE = params.type;
      getDataMap(TYPE).then((res) => {
        let data = [];
        if (res && res.data && res.data.length) {
          data = data.concat(res.data);
          if (field === "typeList") {
            data = this.formatTypeList(data);
          }
        }
        this[field] = data;
      });
    },

    // 保存
    savePart(data) {
      addPart(data)
        .then((res) => {
          res.msg && this.success(res.msg);
          if (res.code !== 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.goBack();
        })
        .catch((_) => _);
    },

    // 编辑
    editPart(data) {
      editPart(data)
        .then((res) => {
          res.msg && this.success(res.msg);
          if (res.code !== 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.goBack();
        })
        .catch((_) => _);
    },

    // 查询
    getPartInfoById() {
      const { uuid } = this.form;
      getPartDetail(uuid)
        .then((res) => {
          this.extend(this.form, res);
          this.form.showType = `${this.form.showType}`;
          if (res.configList && res.configList.length) {
            this.selectedList = res.configList.map((item, idx) => {
              item.name = item.videoName;
              item.order = idx;
              return item;
            });
          }
          this.selectedList = [...res.configList];
        })
        .catch((_) => _);
    },

    removeImage(type) {
      if (type) {
        this.form[type] = "";
        this.form[`_${type}`] = [];
      }
    },

    open() {
      this.selectDialogInfo = {
        flag: true,
        selectedList: this.selectedList,
      }
    },
    closeSelect() {
      this.selectDialogInfo.flag = false
    },

    onFilter(payload) {
      this.selectedList = payload || [];
      this.selectDialogInfo.flag = false
    },

    onRemove(row, idx) {
      if (idx <= this.selectedList.length) {
        this.selectedList.splice(idx, 1);
      }
    },

    onSelectionChange(selection) {
      this.filteredSelectedList = selection;
    },

    onCheck(draggable) {
      this.draggable = draggable;
      // this.toggleDrag(draggable);
    },

    multiRemove() {
      this.onMultiRemove()
        .then(() => {
          const idMap = new Map();
          this.filteredSelectedList.forEach((item) => {
            idMap.set(item.uuid, true);
          });
          let newSelectedList = [];
          this.selectedList.forEach((item) => {
            if (!idMap.has(item.uuid)) {
              newSelectedList.push(item);
            }
          });
          this.selectedList = newSelectedList;
        })
        .catch((_) => _);
    },

    onMultiRemove() {
      return new Promise((resolve, reject) => {
        let msg = "";
        if (this.selectedList.length && this.filteredSelectedList.length) {
          resolve(true);
        } else {
          if (this.selectedList.length === 0) {
            msg = "请先配置视频";
          }
          if (!msg && this.filteredSelectedList.length === 0) {
            msg = "请选择至少一条视频";
          }
          msg && this.warn(msg);
          reject(false);
        }
      });
    },

    warn(msg) {
      msg &&
        this.$message({
          message: msg,
          type: "warning",
        });
    },

    success(msg) {
      msg &&
        this.$message({
          type: "success",
          message: msg,
        });
    },

    goBack() {
      this.$router.push({ ...this.pathOptions });
    },

    submit() {
      // 校验数据完整性
      this.canSubmit()
        .then(() => {
          const data = this.getFormData();
          if (data.uuid) {
            this.editPart(data);
          } else {
            this.savePart(data);
          }
        })
        .catch((_) => _);
    },

    getFormData() {
      const data = {
        ...this.form,
        configDtoList: [],
      };
      // console.log('...selectedList:', this.selectedList);
      this.selectedList.forEach((item, idx) => {
        data.configDtoList.push({
          ...item,
          bizId: item.uuid,
          order: idx,
        });
      });

      delete data._appUrl;
      delete data._webUrl;
      !data.uuid && delete data.uuid;

      return data;
    },

    canSubmit() {
      const vm = this;
      return new Promise((resolve, reject) => {
        let msg = "";
        vm.$refs["basicForm"].validate((res) => {
          if (res) {
            if (vm.selectedList.length === 0) {
              msg = "请先配置视频";
            }
            if (msg) {
              vm.warn(msg);
            } else {
              resolve(true);
            }
          }
          reject(false);
        });
      });
    },

    extend(source, dist) {
      Object.keys(source).forEach((key) => {
        source[key] = dist[key];
      });
    },

    toggleDrag(draggable) {
      if (!draggable) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const that = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        that.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          onEnd({ oldIndex, newIndex }) {
            if (oldIndex === newIndex) return;
            let tempList = JSON.parse(JSON.stringify(that.selectedList));
            const currRow = tempList.splice(oldIndex, 1)[0];
            tempList.splice(newIndex, 0, currRow);
            that.selectedList = tempList;
          },
        });
      }
    },

    formatTypeList(data) {
      const imageMap = {
        1: App_DISPLAY_MODE.ONE,
        2: App_DISPLAY_MODE.TWO,
        3: App_DISPLAY_MODE.THREE,
        4: App_DISPLAY_MODE.FOUR,
      };
      return data.map((item) => {
        item.toooltipImageSrc = imageMap[item.paramKey] || "";
        return item;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  padding: 24px;
  .btn-list {
    margin-bottom: 10px;
    .el-checkbox {
      margin-right: 20px;
    }
  }
  .tip_img {
    margin-top: 6px;
    font-size: 12px;
  }
  .center {
    text-align: center;
  }
}
</style>

<style>
.app_display_mode {
  width: 135px;
  height: 185px;
}
.custom_img_poper {
  border: none !important;
}
</style>
